import React from "react";
import AceEditor from "react-ace";

function CartaPorteXml(props) {
  const { customer, shippingAddress_obj, notes, name, billing_address } =
    props.data[0];
  const address = shippingAddress_obj
    ? shippingAddress_obj.state.split(",")
    : "";
  const addressPlus = address ? address[2]?.split(" ") : "";

  const data = `
  <cfdi:Comprobante xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:cartaporte20="http://www.sat.gob.mx/CartaPorte20" xmlns:cfdi="http://www.sat.gob.mx/cfd/3" xsi:schemaLocation="http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd http://www.sat.gob.mx/CartaPorte20 http://www.sat.gob.mx/sitio_internet/cfd/CartaPorte/CartaPorte20.xsd" Version="3.3" Serie="-" Folio="38" Fecha="2022-09-01T11:35:31" Sello="SUhlrsW4xX8MJ6fd7Ap/tgkC77jXlDPqZMmAJxVrCFiFy1b/Th3ZU9891xKE7/vi4cgOHDbh6yujzUwouFeX1VtrlhvJYYKDwv8YME1LgNaRhCzVgZt20t8BlT3Pjdg2bIj8UgYe5SOJZ9BHpV2x6PwM68tT8kq+Ehzybbt830XX7/Nz7l4WdcPUwB6zfpuMlLE20yl9E6ULYeAuRbYWVgF+YApgRJhW7bGsZVSnrqxaFBnKqVAHQeFIDR+lipjDAa0Z8+gHB5phNmFqVBYbTpL0rJjbZ9IOUwG7F9LYvmaUpiiv6NTU14uwc15f6hX/HJ74X0LVVjf+Ni9IO95lAA==" FormaPago="99" NoCertificado="00001000000507149063" Certificado="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" CondicionesDePago="CONTADO" SubTotal="12.00" Moneda="MXN" Total="13.44" TipoDeComprobante="I" MetodoPago="PPD" LugarExpedicion="32280">
<cfdi:Emisor Rfc="CLT180925CM4" Nombre="${
    customer.name ? customer.name : customer.first_name
  }" RegimenFiscal="601"/>
<cfdi:Receptor Rfc="REMA8603179T1" Nombre="${
    customer.name ? customer.name : customer.first_name
  }" UsoCFDI="P01"/>
<cfdi:Conceptos>
<cfdi:Concepto ClaveProdServ="78101500" Cantidad="1.0000" ClaveUnidad="E48" Unidad="Unidad de servicio" Descripcion="${
    notes ? notes : name
  }" ValorUnitario="12.0000" Importe="12.00">
<cfdi:Impuestos>
<cfdi:Traslados>
<cfdi:Traslado Base="12.00" Impuesto="002" TipoFactor="Tasa" TasaOCuota="0.160000" Importe="1.92"/>
</cfdi:Traslados>
<cfdi:Retenciones>
<cfdi:Retencion Base="12.00" Impuesto="002" TipoFactor="Tasa" TasaOCuota="0.040000" Importe="0.48"/>
</cfdi:Retenciones>
</cfdi:Impuestos>
</cfdi:Concepto>
</cfdi:Conceptos>
<cfdi:Impuestos TotalImpuestosRetenidos="0.48" TotalImpuestosTrasladados="1.92">
<cfdi:Retenciones>
<cfdi:Retencion Impuesto="002" Importe="0.48"/>
</cfdi:Retenciones>
<cfdi:Traslados>
<cfdi:Traslado Impuesto="002" TipoFactor="Tasa" TasaOCuota="0.160000" Importe="1.92"/>
</cfdi:Traslados>
</cfdi:Impuestos>
<cfdi:Complemento>
<tfd:TimbreFiscalDigital xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:tfd="http://www.sat.gob.mx/TimbreFiscalDigital" xsi:schemaLocation="http://www.sat.gob.mx/TimbreFiscalDigital http://www.sat.gob.mx/sitio_internet/cfd/TimbreFiscalDigital/TimbreFiscalDigitalv11.xsd" Version="1.1" UUID="05F4B3C0-D98A-49DD-8C15-E06E5FF58254" FechaTimbrado="2022-09-02T13:31:25" RfcProvCertif="PPD101129EA3" SelloCFD="SUhlrsW4xX8MJ6fd7Ap/tgkC77jXlDPqZMmAJxVrCFiFy1b/Th3ZU9891xKE7/vi4cgOHDbh6yujzUwouFeX1VtrlhvJYYKDwv8YME1LgNaRhCzVgZt20t8BlT3Pjdg2bIj8UgYe5SOJZ9BHpV2x6PwM68tT8kq+Ehzybbt830XX7/Nz7l4WdcPUwB6zfpuMlLE20yl9E6ULYeAuRbYWVgF+YApgRJhW7bGsZVSnrqxaFBnKqVAHQeFIDR+lipjDAa0Z8+gHB5phNmFqVBYbTpL0rJjbZ9IOUwG7F9LYvmaUpiiv6NTU14uwc15f6hX/HJ74X0LVVjf+Ni9IO95lAA==" NoCertificadoSAT="30001000000400002495" SelloSAT="rjdmQtGwhWEDGWC1R1sNELNPekImWGnecso1VtYYowfsHgMgEdCCN0O8zFg5ulNowqk68JSCIYiJkGUh0djUvqGVmAht1eUuD9qOZ4n0/97KQyxfT/HEgPafxhM9CHiM1k6jT4vuRZW4HXzeeK8gL2H6F23iucgDPYf54wYH/9ylDbUGaGA6ZhNNJhSqDmcO41CQgnCp1m+DNUDNs73LCr5KMZtBa8MHg5RJGzJMN2dmFdN+nyN8Q6X1K1sXqh3AErOKnwLYeDxDowPjODL9RbjY/d0dQgYkIJLljD4WzIopzNlf2YsYnsjxaClrxlknzws5CEQVlfbzgdwDH81XvA=="/>
<cartaporte20:CartaPorte xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:cartaporte20="http://www.sat.gob.mx/CartaPorte20" xsi:schemaLocation="http://www.sat.gob.mx/CartaPorte20 http://www.sat.gob.mx/sitio_internet/cfd/CartaPorte/CartaPorte20.xsd" Version="2.0" TranspInternac="Sí" EntradaSalidaMerc="Salida" PaisOrigenDestino="USA" ViaEntradaSalida="01" TotalDistRec="12.00">
<cartaporte20:Ubicaciones>
<cartaporte20:Ubicacion TipoUbicacion="Origen" IDUbicacion="OR000001" RFCRemitenteDestinatario="ESP060405HL6" FechaHoraSalidaLlegada="2022-08-30T14:19:45">
<cartaporte20:Domicilio Calle="10025 Siempre Viva Rd" NumeroExterior="8207" Colonia="0946" Localidad="06" Municipio="San Diego" Estado="CA" Pais="US" CodigoPostal="92154"/>
</cartaporte20:Ubicacion>
<cartaporte20:Ubicacion TipoUbicacion="Destino" IDUbicacion="DE000002" RFCRemitenteDestinatario="XEXX010101000" NumRegIdTrib="1234567890" ResidenciaFiscal="USA" FechaHoraSalidaLlegada="2022-08-29T12:00:00" DistanciaRecorrida="12.00">
<cartaporte20:Domicilio Calle="${
    address[0] ? address[0] : billing_address.address1
  }" Colonia="" Localidad="${
    address[1] ? address[1] : billing_address.city
  }" Municipio="${address[1] ? address[1] : billing_address.city}" Estado="${
    addressPlus[1] ? addressPlus[1] : billing_address.province_code
  }" Pais="USA" CodigoPostal="${
    addressPlus[2] ? addressPlus[2] : billing_address.zip
  }"/>
</cartaporte20:Ubicacion>
</cartaporte20:Ubicaciones>
<cartaporte20:Mercancias PesoBrutoTotal="12.000" UnidadPeso="KGM" NumTotalMercancias="1">
<cartaporte20:Mercancia BienesTransp="43211600" Descripcion="${
    notes ? notes : name
  }" Cantidad="1.0000" ClaveUnidad="E48" PesoEnKg="12.000" ValorMercancia="12.00" Moneda="USD" FraccionArancelaria="0101290300">
<cartaporte20:CantidadTransporta Cantidad="1.0000" IDOrigen="OR000001" IDDestino="DE000002"/>
</cartaporte20:Mercancia>
<cartaporte20:Autotransporte PermSCT="TPAF02" NumPermisoSCT="0811CLT13012020133901013">
<cartaporte20:IdentificacionVehicular ConfigVehicular="C2R2" PlacaVM="89EP1M" AnioModeloVM="2021"/>
<cartaporte20:Seguros AseguraRespCivil="AXA" PolizaRespCivil="140226946600" PrimaSeguro="4361.19"/>
<cartaporte20:Remolques>
<cartaporte20:Remolque SubTipoRem="CTR001" Placa="C3DFR45"/>
</cartaporte20:Remolques>
</cartaporte20:Autotransporte>
</cartaporte20:Mercancias>
<cartaporte20:FiguraTransporte>
<cartaporte20:TiposFigura TipoFigura="01" RFCFigura="LURJ890910PKA" NumLicencia="CHIH222634"/>
</cartaporte20:FiguraTransporte>
</cartaporte20:CartaPorte>
</cfdi:Complemento>
</cfdi:Comprobante>
`;

  return (
    <div
      className="mt-2 w-full h-full pb-10 pr-10 pl-10"
      style={{
        overflowY: "scroll",
        wordWrap: "break-word",
        marginBottom: 20,
      }}
    >
      <AceEditor
        width="100%"
        height="100%"
        mode="javascript"
        theme="tomorrow"
        name="editor"
        value={data}
        fontSize={14}
        editorProps={{ $blockScrolling: true }}
      />
      {/* <div>{`<cfdi:comprobante`}</div>
      <div>{`xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"`}</div>
      <div>{`xmlns:cartaporte20="http://www.sat.gob.mx/CartaPorte20"`}</div>
      <div>{`xmlns:cfdi="http://www.sat.gob.mx/cfd/3"`}</div>
      <div>{`xsi:schemalocation="http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd http://www.sat.gob.mx/CartaPorte20 http://www.sat.gob.mx/sitio_internet/cfd/CartaPorte/CartaPorte20.xsd"`}</div>
      <div>{`version="3.3"`}</div>
      <div>{`  serie="-"`}</div>
      <div>{`folio={38}`}</div>
      <div>{`  fecha="2022-09-01T11:35:31"`}</div>
      <div>{`sello="SUhlrsW4xX8MJ6fd7Ap/tgkC77jXlDPqZMmAJxVrCFiFy1b/Th3ZU9891xKE7/vi4cgOHDbh6yujzUwouFeX1VtrlhvJYYKDwv8YME1LgNaRhCzVgZt20t8BlT3Pjdg2bIj8UgYe5SOJZ9BHpV2x6PwM68tT8kq+Ehzybbt830XX7/Nz7l4WdcPUwB6zfpuMlLE20yl9E6ULYeAuRbYWVgF+YApgRJhW7bGsZVSnrqxaFBnKqVAHQeFIDR+lipjDAa0Z8+gHB5phNmFqVBYbTpL0rJjbZ9IOUwG7F9LYvmaUpiiv6NTU14uwc15f6hX/HJ74X0LVVjf+Ni9IO95lAA=="`}</div>
      <div>{`formapago={99}`}</div>
      <div>{`  nocertificado={00001000000507149063}`}</div>
      <div>{`certificado="MIIGJjCCBA6gAwIBAgIUMDAwMDEwMDAwMDA1MDcxNDkwNjMwDQYJKoZIhvcNAQELBQAwggGEMSAwHgYDVQQDDBdBVVRPUklEQUQgQ0VSVElGSUNBRE9SQTEuMCwGA1UECgwlU0VSVklDSU8gREUgQURNSU5JU1RSQUNJT04gVFJJQlVUQVJJQTEaMBgGA1UECwwRU0FULUlFUyBBdXRob3JpdHkxKjAoBgkqhkiG9w0BCQEWG2NvbnRhY3RvLnRlY25pY29Ac2F0LmdvYi5teDEmMCQGA1UECQwdQVYuIEhJREFMR08gNzcsIENPTC4gR1VFUlJFUk8xDjAMBgNVBBEMBTA2MzAwMQswCQYDVQQGEwJNWDEZMBcGA1UECAwQQ0lVREFEIERFIE1FWElDTzETMBEGA1UEBwwKQ1VBVUhURU1PQzEVMBMGA1UELRMMU0FUOTcwNzAxTk4zMVwwWgYJKoZIhvcNAQkCE01yZXNwb25zYWJsZTogQURNSU5JU1RSQUNJT04gQ0VOVFJBTCBERSBTRVJWSUNJT1MgVFJJQlVUQVJJT1MgQUwgQ09OVFJJQlVZRU5URTAeFw0yMTA0MjAyMjU1MTZaFw0yNTA0MjAyMjU1MTZaMIH0MTEwLwYDVQQDFChDJkwgTE9HSVNUSUNBIFkgVFJBTlNQT1JURSBTIERFIFJMIERFIENWMTEwLwYDVQQpFChDJkwgTE9HSVNUSUNBIFkgVFJBTlNQT1JURSBTIERFIFJMIERFIENWMTEwLwYDVQQKFChDJkwgTE9HSVNUSUNBIFkgVFJBTlNQT1JURSBTIERFIFJMIERFIENWMSUwIwYDVQQtExxDTFQxODA5MjVDTTQgLyBWSUNNNjcwMTExUlMzMR4wHAYDVQQFExUgLyBWSUNNNjcwMTExTUNITFJSMDgxEjAQBgNVBAsTCWxvZ2lzdGljYTCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAIYjKQz9nZQQGkcBLMYriio3Ys24wiEsGaeJybtngsiB6e2Iv9JT594TA+sN3fuOYap8sf7RH9HWrR9mtz2ugisFNycj7o5fY3USCuvCrdzHEiX3zEZe4pbDaBeFDhkgm3J1SPrs65iyakkQfJm4uHgAo7MPHSY2OxXiVxgEztsefFSzXTpGwDis0+IDJpKWR1kO4TT5Wsog9gYO7wNJSLud0YjTviVZby3vEdeNd7taX35XP5WM5RoCVzFZyHh4+CncjZxfeq5z5nRN3ejxP9BvFvBGUdndshs+AqJ/EP06NLkzqvzt6ff8eAx8/rcX2Mbv70pNgkR6q3ICgH2yVw0CAwEAAaMdMBswDAYDVR0TAQH/BAIwADALBgNVHQ8EBAMCBsAwDQYJKoZIhvcNAQELBQADggIBAEqaebket6TOQREVtzixlUO/k3Y+DwQop0SJor/eZ+3Ewy8wpxOHjmUIdOr+tMHZ927onJ2yERXgM/w2i0ZevgPXwAzU+SgPFmSAh2AoeTAbHlXjuABhiTWM27pVbNASWy9U885C2/+zWGbaSOlvtg3obPvO8G9nEardBf11jqih8uPptCicp/MrTAUbIBxWIrNlvWfAe9NALRVKeKmpAtWAoSHPDhPQUCMwgOyJ2fAI0jbqp4S4Jpn8Ct9kGm2ujLoep441YmWoPpLGjT7J47sgUb9FTFbEmUYyIS0jZUwhZ48rICWhW/5/45o8kXkZv1nIhxSsR1UFs+T54bcMXkWqWz5GGtj4NmVp9FnWiBW1+Anx/1qweUFVIe82oABx5YgqjheQwS4JAlhTFW2NUwacytBk2kT2uFw3HH8+xedwmH2jiLIFyZMYIl3c1iemRmYVgYehw1ZAR4aJ/uY5spexMnZxFEGLC7I0Ee7WiskefziqgzgHdgNiKJpi5IMrOA31/0DRFMaDwmF10I+ZO8brsagct4ng5+k+SxJ0bVwmSHKhgql89tZiSrm7Fhs39Sjf67FWZSle92aHGL6701mpS76oOegFwRj2TatIVGRASmfk+BZ5RslU9KEQisX7tJyRC1UJVIFHZ101theqobVSKjDBfdwSfTloDinfNjk4"`}</div>
      <div>{`condicionesdepago="CONTADO"`}</div>
      <div>{`subtotal={10.0}`}</div>
      <div>{`moneda="USD"`}</div>
      <div>{`total="10.00"`}</div>
      <div>{`tipodecomprobante="I"`}</div>
      <div>{`metodopago="PPD"`}</div>
      <div>{`lugarexpedicion={32280}`}</div>
      <div>{`>`}</div>
      <div>{`  <cfdi:emisor`}</div>
      <div>{`rfc="CLT180925CM4"`}</div>
      <div>{`nombre="${
        customer.name ? customer.name : customer.first_name
      }"`}</div>
      <div>{`regimenfiscal={601}`}</div>
      <div>{`>`}</div>
      <div>{`  <cfdi:receptor rfc="REMA8603179T1" nombre="${
        customer.name ? customer.name : customer.first_name
      }" usocfdi="P01">`}</div>
      <div>{`<cfdi:conceptos>`}</div>
      <div>{`<cfdi:concepto`}</div>
      <div>{`claveprodserv={78101500}`}</div>
      <div>{`cantidad={1.0}`}</div>
      <div>{` claveunidad="E48"`}</div>
      <div>{`unidad="Unidad de servicio"`}</div>
      <div>{`descripcion="${notes ? notes : name}"`}</div>
      <div>{`valorunitario={10.0}`}</div>
      <div>{`importe={10.0}`}</div>
      <div>{`>`}</div>
      <div>{`<cfdi:impuestos>`}</div>
      <div>{`<cfdi:traslados>`}</div>
      <div>{`<cfdi:traslado`}</div>
      <div>{`base={12.0}`}</div>
      <div>{`impuesto={002}`}</div>
      <div>{`tipofactor="Tasa"`}</div>
      <div>{`tasaocuota="0.160000"`}</div>
      <div>{` importe="1.92"`}</div>
      <div>{`></cfdi:traslado>`}</div>
      <div>{`</cfdi:traslados>`}</div>
      <div>{` <cfdi:retenciones>`}</div>
      <div>{`<cfdi:retencion`}</div>
      <div>{`base={12.0}`}</div>
      <div>{`impuesto={002}`}</div>
      <div>{`tipofactor="Tasa"`}</div>
      <div>{`tasaocuota="0.040000"`}</div>
      <div>{`importe="0.48"`}</div>
      <div>{`></cfdi:retencion>`}</div>
      <div>{`</cfdi:retenciones>`}</div>
      <div>{`</cfdi:impuestos>`}</div>
      <div>{`</cfdi:concepto>`}</div>
      <div>{`</cfdi:conceptos>`}</div>
      <div>{`<cfdi:impuestos`}</div>
      <div>{`totalimpuestosretenidos="0.48"`}</div>
      <div>{`totalimpuestostrasladados="1.92"`}</div>
      <div>{`>`}</div>
      <div>{` <cfdi:retenciones>`}</div>
      <div>{`<cfdi:retencion impuesto={002} importe="0.48"></cfdi:retencion>`}</div>
      <div>{`</cfdi:retenciones>`}</div>
      <div>{` <cfdi:traslados>`}</div>
      <div>{`<cfdi:traslado`}</div>
      <div>{`impuesto={002}`}</div>
      <div>{`tipofactor="Tasa"`}</div>
      <div>{`tasaocuota="0.160000"`}</div>
      <div>{`importe="1.92"`}</div>
      <div>{`></cfdi:traslado>`}</div>
      <div>{`</cfdi:traslados>`}</div>
      <div>{`</cfdi:impuestos>`}</div>
      <div>{`<cfdi:complemento>`}</div>
      <div>{`<tfd:timbrefiscaldigital`}</div>
      <div>{`xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"`}</div>
      <div>{`xmlns:tfd="http://www.sat.gob.mx/TimbreFiscalDigital"`}</div>
      <div>{`xsi:schemalocation="http://www.sat.gob.mx/TimbreFiscalDigital http://www.sat.gob.mx/sitio_internet/cfd/TimbreFiscalDigital/TimbreFiscalDigitalv11.xsd"`}</div>
      <div>{`version="1.1"`}</div>
      <div>{`uuid="05F4B3C0-D98A-49DD-8C15-E06E5FF58254"`}</div>
      <div>{`fechatimbrado="2022-09-02T13:31:25"`}</div>
      <div>{`rfcprovcertif="PPD101129EA3"`}</div>
      <div>{`sellocfd="SUhlrsW4xX8MJ6fd7Ap/tgkC77jXlDPqZMmAJxVrCFiFy1b/Th3ZU9891xKE7/vi4cgOHDbh6yujzUwouFeX1VtrlhvJYYKDwv8YME1LgNaRhCzVgZt20t8BlT3Pjdg2bIj8UgYe5SOJZ9BHpV2x6PwM68tT8kq+Ehzybbt830XX7/Nz7l4WdcPUwB6zfpuMlLE20yl9E6ULYeAuRbYWVgF+YApgRJhW7bGsZVSnrqxaFBnKqVAHQeFIDR+lipjDAa0Z8+gHB5phNmFqVBYbTpL0rJjbZ9IOUwG7F9LYvmaUpiiv6NTU14uwc15f6hX/HJ74X0LVVjf+Ni9IO95lAA=="`}</div>
      <div>{`nocertificadosat={30001000000400002495}`}</div>
      <div>{`sellosat="rjdmQtGwhWEDGWC1R1sNELNPekImWGnecso1VtYYowfsHgMgEdCCN0O8zFg5ulNowqk68JSCIYiJkGUh0djUvqGVmAht1eUuD9qOZ4n0/97KQyxfT/HEgPafxhM9CHiM1k6jT4vuRZW4HXzeeK8gL2H6F23iucgDPYf54wYH/9ylDbUGaGA6ZhNNJhSqDmcO41CQgnCp1m+DNUDNs73LCr5KMZtBa8MHg5RJGzJMN2dmFdN+nyN8Q6X1K1sXqh3AErOKnwLYeDxDowPjODL9RbjY/d0dQgYkIJLljD4WzIopzNlf2YsYnsjxaClrxlknzws5CEQVlfbzgdwDH81XvA=="`}</div>
      <div>{`>`}</div>
      <div>{` <cartaporte20:cartaporte`}</div>
      <div>{`xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"`}</div>
      <div>{`xmlns:cartaporte20="http://www.sat.gob.mx/CartaPorte20"`}</div>
      <div>{`xsi:schemalocation="http://www.sat.gob.mx/CartaPorte20 http://www.sat.gob.mx/sitio_internet/cfd/CartaPorte/CartaPorte20.xsd"`}</div>
      <div>{` version={2.0}`}</div>
      <div>{`transpinternac="Sí"`}</div>
      <div>{`entradasalidamerc="Salida"`}</div>
      <div>{`paisorigendestino="USA"`}</div>
      <div>{`viaentradasalida={01}`}</div>
      <div>{`totaldistrec={12.0}`}</div>
      <div>{` >`}</div>
      <div>{`<cartaporte20:ubicaciones>`}</div>
      <div>{`<cartaporte20:ubicacion`}</div>
      <div>{`tipoubicacion="Origen"`}</div>
      <div>{`idubicacion="OR000001"`}</div>
      <div>{`rfcremitentedestinatario="ESP060405HL6"`}</div>
      <div>{`fechahorasalidallegada="2022-08-30T14:19:45"`}</div>
      <div>{`>`}</div>
      <div>{`<cartaporte20:domicilio`}</div>
      <div>{`calle="10025 Siempre Viva Rd"`}</div>
      <div>{`numeroexterior={8207}`}</div>
      <div>{`colonia={0946}`}</div>
      <div>{`localidad={06}`}</div>
      <div>{`municipio={San Diego}`}</div>
      <div>{`estado="CA"`}</div>
      <div>{`pais="US"`}</div>
      <div>{`codigopostal={92154}`}</div>
      <div>{`></cartaporte20:domicilio>`}</div>
      <div>{`</cartaporte20:ubicacion>`}</div>
      <div>{`<cartaporte20:ubicacion`}</div>
      <div>{` tipoubicacion="Destino"`}</div>
      <div>{`idubicacion="DE000002"`}</div>
      <div>{`rfcremitentedestinatario="XEXX010101000"`}</div>
      <div>{`numregidtrib={1234567890}`}</div>
      <div>{`residenciafiscal="USA"`}</div>
      <div>{`fechahorasalidallegada="2022-08-29T12:00:00"`}</div>
      <div>{`distanciarecorrida={12.0}`}</div>
      <div>{`>`}</div>
      <div>{`<cartaporte20:domicilio`}</div>
      <div>{`calle="${
        address[0] ? address[0] : billing_address.address1
      }"`}</div>
      <div>{`colonia={}`}</div>
      <div>{` localidad="${
        address[1] ? address[1] : billing_address.city
      }"`}</div>
      <div>{`municipio="${
        address[1] ? address[1] : billing_address.city
      }"`}</div>
      <div>{`estado="${
        addressPlus[1] ? addressPlus[1] : billing_address.province_code
      }"`}</div>
      <div>{` pais="USA"`}</div>
      <div>{`codigopostal={${
        addressPlus[2] ? addressPlus[2] : billing_address.zip
      }}`}</div>
      <div>{`></cartaporte20:domicilio>`}</div>
      <div>{` </cartaporte20:ubicacion>`}</div>
      <div>{`</cartaporte20:ubicaciones>`}</div>
      <div>{`<cartaporte20:mercancias`}</div>
      <div>{`pesobrutototal={12.0}`}</div>
      <div>{`unidadpeso="KGM"`}</div>
      <div>{`numtotalmercancias={1}`}</div>
      <div>{`>`}</div>
      <div>{` <cartaporte20:mercancia`}</div>
      <div>{`bienestransp={43211600}`}</div>
      <div>{`descripcion="Descripcion"`}</div>
      <div>{`cantidad={1.0}`}</div>
      <div>{`claveunidad="E48"`}</div>
      <div>{`pesoenkg={12.0}`}</div>
      <div>{`valormercancia={12.0}`}</div>
      <div>{`moneda="USD"`}</div>
      <div>{`fraccionarancelaria={0101290300}`}</div>
      <div>{`>`}</div>
      <div>{`<cartaporte20:cantidadtransporta`}</div>
      <div>{`cantidad={1.0}`}</div>
      <div>{`idorigen="OR000001"`}</div>
      <div>{`iddestino="DE000002"`}</div>
      <div>{` ></cartaporte20:cantidadtransporta>`}</div>
      <div>{`</cartaporte20:mercancia>`}</div>
      <div>{`<cartaporte20:autotransporte`}</div>
      <div>{`permsct="TPAF02"`}</div>
      <div>{`numpermisosct="0811CLT13012020133901013"`}</div>
      <div>{`>`}</div>
      <div>{`<cartaporte20:identificacionvehicular`}</div>
      <div>{`configvehicular="C2R2"`}</div>
      <div>{`placavm="89EP1M"`}</div>
      <div>{`aniomodelovm={2021}`}</div>
      <div>{`>`}</div>
      <div>{`<cartaporte20:seguros`}</div>
      <div>{`asegurarespcivil="AXA"`}</div>
      <div>{`polizarespcivil={140226946600}`}</div>
      <div>{`primaseguro="4361.19"`}</div>
      <div>{`>`}</div>
      <div>{`<cartaporte20:remolques>`}</div>
      <div>{`<cartaporte20:remolque`}</div>
      <div>{`subtiporem="CTR001"`}</div>
      <div>{`placa="C3DFR45"`}</div>
      <div>{` ></cartaporte20:remolque>`}</div>
      <div>{` </cartaporte20:remolques>`}</div>
      <div>{` </cartaporte20:seguros>`}</div>
      <div>{`</cartaporte20:identificacionvehicular>`}</div>
      <div>{` </cartaporte20:autotransporte>`}</div>
      <div>{`</cartaporte20:mercancias>`}</div>
      <div>{`<cartaporte20:figuratransporte>`}</div>
      <div>{`<cartaporte20:tiposfigura`}</div>
      <div>{`tipofigura={01}`}</div>
      <div>{`rfcfigura="LURJ890910PKA"`}</div>
      <div>{`numlicencia="CHIH222634"`}</div>
      <div>{`></cartaporte20:tiposfigura>`}</div>
      <div>{`</cartaporte20:figuratransporte>`}</div>
      <div>{`</cartaporte20:cartaporte>`}</div>
      <div>{`</tfd:timbrefiscaldigital>`}</div>
      <div>{` </cfdi:complemento>`}</div>
      <div>{`</cfdi:receptor>`}</div>
      <div>{`</cfdi:emisor>`}</div>
      <div>{`</cfdi:comprobante>`}</div> */}
    </div>
  );
}

export default CartaPorteXml;
